const APP_HOST = 'app.bkr.se';
const APP_SCHEME = 'se.bkr:';
const SAFE_ID_PATTERN = /^[A-Za-z0-9._-]+$/;

export interface AppOpenTarget {
  pathname: string;
  search: string;
  isQualityDocument: boolean;
}

export function isSafeId(value?: string | null) {
  return typeof value === 'string' && SAFE_ID_PATTERN.test(value);
}

export function qualityDocumentPath(projectId: string, documentId: string) {
  return `/projects/${projectId}/qualitydocument/${documentId}/`;
}

export function parseAppOpenUrl(url: string): AppOpenTarget | null {
  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.protocol === APP_SCHEME) {
      const projectId = parsedUrl.searchParams.get('projectId');
      const documentId = parsedUrl.searchParams.get('documentId');

      if (typeof projectId !== 'string' || typeof documentId !== 'string' || !isSafeId(projectId) || !isSafeId(documentId)) {
        return null;
      }

      return {
        pathname: qualityDocumentPath(projectId, documentId),
        search: '',
        isQualityDocument: true,
      };
    }

    if (parsedUrl.host !== APP_HOST) {
      return null;
    }

    const signReturnProjectId = parsedUrl.searchParams.get('projectId');
    const signReturnDocumentId = parsedUrl.searchParams.get('documentId');

    if (
      parsedUrl.pathname.includes('/sign-return')
      && typeof signReturnProjectId === 'string'
      && typeof signReturnDocumentId === 'string'
      && isSafeId(signReturnProjectId)
      && isSafeId(signReturnDocumentId)
    ) {
      return {
        pathname: qualityDocumentPath(signReturnProjectId, signReturnDocumentId),
        search: '',
        isQualityDocument: true,
      };
    }

    const isQualityDocument = parsedUrl.pathname.includes('/qualitydocument/');
    const pathname = isQualityDocument
      && !parsedUrl.pathname.endsWith('/')
      && !parsedUrl.pathname.endsWith('/edit')
      ? `${parsedUrl.pathname}/`
      : parsedUrl.pathname;

    return {
      pathname,
      search: parsedUrl.search,
      isQualityDocument,
    };
  } catch (e) {
    return null;
  }
}
